import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  dayOrdinal: {
    id: 'dayOrdinal',
    defaultMessage: `{day, selectordinal,
      one {#st}
      two {#nd}
      few {#rd}
      other {#th}
    }`,
  },
  nonUSPrices: {
    id: 'nonUSPrices',
    defaultMessage: '{price} USD',
  },
});

export const localeCurrencyMap = {
  'en-US': 'USD',
  'en-AU': 'AUD',
  'en-NZ': 'NZD',
};
